import styled from 'styled-components'
import FilterListIcon from '@mui/icons-material/FilterList'
import useViewport from '../../hooks/useViewport'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  height: 36px;
  padding: 0 16px;
  border-radius: 50px;
  background-color: #f1f3f5;
  cursor: pointer;
`

const Filter = ({ onClick }) => {
  const { width } = useViewport()
  const { t } = useTranslation('common')

  return (
    <Container onClick={onClick}>
      <FilterListIcon sx={{ color: '#858B92' }} />
      {width > 830 && <span>{t('filter.title')}</span>}
    </Container>
  )
}

export default Filter
